module.exports = __webpack_public_path__ + "img/form_description_file.e375d2b1.svg";